import { Tag } from '@playq/octopus-common';

export const isSystemTag = (tag: Tag): boolean => tag.key.startsWith('$') || tag.key.startsWith('-$');
